import React from "react";
//outsource
import { Row, Col, Select, Form } from "antd";

//components
import lodash from "lodash";
//redux
import { useSelector } from "react-redux";
import { allSelector } from "../../../../store/group_service/group.selector";

const ServiceSelectGroup = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const group = useSelector(allSelector);
  console.log({ group });
  // -------------------------- FUNCTION -----------------------

  // -------------------------- EFFECT -------------------------

  // -------------------------- RENDER -------------------------

  // -------------------------- MAIN ---------------------------
  const options = renderOptions(group);
  return (
    <Form.Item
      name="group"
      label="Group"
      rules={[
        {
          required: true,
          message: "Please select the group",
        },
      ]}
    >
      <Select placeholder="Group" options={options || []} />
    </Form.Item>
  );
};

export default ServiceSelectGroup;

const renderOptions = (data) => {
  const sort = lodash.orderBy(data, ["name"]);

  const newData = sort?.map((item) => {
    const value = item?.id;
    const label = item?.name?.toUpperCase();

    return {
      value,
      label,
    };
  });

  return newData;
};
